module.exports = __webpack_public_path__ + "media/watchwin.00fa67bc.mp4";